<template>
	<v-table>
		<thead>
			<tr>
				<th>ICAO Code</th>
				<th>Name</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="item in airports" :key="item._id">
				<td>{{ item.name }}</td>
				<td>{{ item.state }}</td>
			</tr>
		</tbody>
	</v-table>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
	computed: {
		...mapState({
			token: "token",
		}),
	},
	data() {
		return {
			airports: "",
		};
	},
	mounted() {
		axios
			.get(process.env.VUE_APP_BACKEND_URL + "/airport", {
				headers: {
					Authorization: "bearer " + this.token,
				},
			})
			.then((response) => {
				console.log(response);
				this.airports = response.data;
			})
			.catch((e) => {
				console.error(e);
			});
	},
};
</script>

<style></style>
